module.exports = __webpack_public_path__ + "static/img/img_cat_02.eb24e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_cat_02.png
// module id = 36
// module chunks = 1